import React, { useState, useEffect, useRef } from 'react';
import { Card, Form, Button, Spinner, Col, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import { useProvider, Toast } from '../context/MenuProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import AOS from "aos";
import 'aos/dist/aos.css';

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");


const VendaList = () => {
  const [query, setQuery] = useState('');
  const [extra, setExtra] = useState(null);
  const [vendas, setVendas] = useState([]);
  const [mes, ano] = [new Date().getMonth(), new Date().getFullYear()];
  const [mesAno, setMesAno] = useState({mes, ano});
  const [filtro, setFiltro] = useState('ultimos_30');
  const [nextUrl, setNextUrl] = useState(null);
  const [avancada, setAvancada] = useState(false);
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const { 
    setLinks, 
    setBtns,
    crud,
    auth,
    salvarDados,
    buscarDados,
    buscarDadosPorId,
  } = useProvider();
  const {get, loading} = crud|| {};
  const meses = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];
  
  const getAnos = (data) => {
    const hoje = dayjs();
    const primeiraVenda = dayjs(data);
    return hoje.diff(primeiraVenda, 'year');
  };

  const anos = Array.from({ length: getAnos(auth?.empresa?.data_primeira_venda) + 1 }, (_, i) => new Date().getFullYear() - i);
  
  
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const pagina = queryParams.get('tipo')?.toLowerCase();
  
  
  useEffect(() => {
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
  }, []);
  
  const isConsultaCarregada = useRef(false);
  const buscarVendasLocal = async () =>{
    try{
      const response = await buscarDados(
        "db_vendas",
        (item) =>{
          const dataItem = new Date(item.data_da_venda).getTime();
          const dataIn = new Date(dataInicio).getTime();
          const dataOut = new Date(dataFim).getTime();
          const periodos = (dataInicio && dataFim)
              ? dataItem >= dataIn && dataItem <= dataOut
              : (dataInicio) ? dataItem >= dataIn : (dataFim) ? dataItem <= dataOut : true
          const pAberto = pagina === "aberto"
              ? parseFloat(item.total_pago || 0) === 0
              : true
          const pParcial = pagina === "parcial"
              ? parseFloat(item.total_pago || 0) > 0 && parseFloat(item.total_aberto || 0) > 0
              : true
          return periodos && pAberto && pParcial;
        },
        40,
        "data_da_venda",
        "desc"
      );
      if (isConsultaCarregada.current) return;
      if(response && response.length){
        for (let item of response){
          item.cliente = await buscarDadosPorId("db_clientes", parseInt(item?.cliente?.id || item.cliente || 0));
        }
        setVendas(response);
      }
      else{
        setVendas([]);
      }
    }catch (err){

    }finally{

    }
  }
  
  const buscarVendas = async (novaBusca = false) => {
    let url = `/gvendas/vendas/?filtros=id,data_da_venda,desconto,sub_total,total,total_pago,nome_do_cliente,total_aberto`;
    if (query) url += `&search=${query}`;
    if (pagina === 'aberto') url += `&total_pago=0&cliente__ativo=true`;
    else if (pagina === 'parcial') url += `&total_pago__gt=0&total_aberto__gt=0&cliente__ativo=true`;

    if (dataInicio) url += `&data_da_venda__gte=${dataInicio}`;
    if (dataFim) url += `&data_da_venda__lte=${dataFim}`;
    url+= `&ordering=-data_da_venda&expand=cliente,extra`;

    if (novaBusca) {
      setExtra(null);
      setNextUrl(null);
    } else if (nextUrl) {
      url = nextUrl;
    } else {
      url = null;
    }
    

    if (!url) return;
    try {
      const response = await get(url,'pagina');
      if (response && response.length) {
        isConsultaCarregada.current = true;
        const novosVendas = response[0].results;
        setVendas((vendasAnteriores) => novaBusca ? novosVendas : [...vendasAnteriores, ...novosVendas]);
        let extra = response[0].extra;
        if (extra){
          extra.quantidade = response[0].count;
        }
        setExtra(extra)
        setNextUrl(response[0].next);
        await salvarDados("db_vendas", novosVendas);
        
      }
    } catch (err) {
    } finally {
      
    }
  };
  
  useEffect(() => {
      setLinks([]);
      setBtns([
        {icon:'bi-funnel'+(avancada?'-fill':''), onClick:() => {setAvancada(!avancada);}},
      ]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns, avancada]);
    

  useEffect(() => {
    buscarVendasLocal();
    buscarVendas(true);
  }, [query, pagina, dataInicio, dataFim]);
  
  useEffect(()=>{
    switch(pagina){
      case 'aberto':
        setFiltro('todo');
        return
      case 'parcial':
        setFiltro('todo');
        return
    }
  },[pagina])
  
  useEffect(()=>{
      const data = new Date();
      var dataInicial;
      var dataFinal;
      
      switch (filtro){
        case "mes_atual":
          dataInicial = new Date(data.getFullYear(), data.getMonth(), 1);
          setDataInicio(dataInicial.toLocaleDateString('sv-SE'));
          setDataFim(data.toLocaleDateString('sv-SE'));
          return
        case "mes_passado":
          dataInicial = new Date(data.getFullYear(), data.getMonth()-1, 1);
          dataFinal = new Date(data.getFullYear(), data.getMonth(), 0);
          setDataInicio(dataInicial.toLocaleDateString('sv-SE'));
          setDataFim(dataFinal.toLocaleDateString('sv-SE'));
          return
        case "ultimos_30":
          dataInicial = new Date(data.getFullYear(), data.getMonth(), data.getDate());
          dataInicial.setDate(dataInicial.getDate()-30);
          setDataInicio(dataInicial.toLocaleDateString('sv-SE'));
          setDataFim(data.toLocaleDateString('sv-SE'));
          return
        case "ultimos_60":
          dataInicial = new Date(data.getFullYear(), data.getMonth(), data.getDate());
          dataInicial.setDate(dataInicial.getDate()-60);
          setDataInicio(dataInicial.toLocaleDateString('sv-SE'));
          setDataFim(data.toLocaleDateString('sv-SE'));
          return
        case "ultimos_90":
          dataInicial = new Date(data.getFullYear(), data.getMonth(), data.getDate());
          dataInicial.setDate(dataInicial.getDate()-90);
          setDataInicio(dataInicial.toLocaleDateString('sv-SE'));
          setDataFim(data.toLocaleDateString('sv-SE'));
          return
        case "todo":
          setDataInicio('');
          setDataFim('');
          return
        case "mes_selecao":
          dataInicial = new Date(mesAno?.ano || anos[0], mesAno?.mes||0, 1);
          dataFinal = new Date(mesAno?.ano || anos[0], parseInt(mesAno?.mes||0)+1, 0);
          setDataInicio(dataInicial.toLocaleDateString('sv-SE'));
          setDataFim(dataFinal.toLocaleDateString('sv-SE'));
          return
      }

  },[filtro, mesAno])
  

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        if (!loading) buscarVendas();
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [nextUrl, loading]);


  const vendasAgrupadas = vendas.reduce((acc, venda) => {
    const data = dayjs(venda.data_da_venda).format("DD/MM/YYYY dddd");
    if (!acc[data]) {
      acc[data] = [];
    }
    acc[data].push(venda);
    return acc;
  }, {});
  
  const getImgStatus = (x) => {
    if(x.total_aberto <= 0){
      return '/images/img_pago.jpg';
    }else if(x.total_aberto > 0 && x.total_pago > 0){
      return '/images/img_parcial.jpg';
    }else{
      return '/images/img_fiado.jpg';
    }
  }
  

  return (
    <>
      <MenuRodape extra={extra}/>
      <BotaoFlutuante to="/checkout/selecionar-cliente" icon="bi-plus" posicao={extra?'2':'1'}></BotaoFlutuante>
      <div className="" data-aos="fade-up">
        <Form>
          {avancada &&(
            <Form.Group controlId="formBasicSearch">
              <div className="input-group">
                <Form.Control 
                  type="text" 
                  placeholder="Digite o nome do cliente" 
                  value={query} 
                  onChange={(e) => setQuery(e.target.value)} 
                />
                  <Button variant="secondary" onClick={() => buscarVendas(true)}>
                    <i className="bi bi-search"></i>
                  </Button>
              </div>
            </Form.Group>
          )}
        </Form>
        <Row>
          <Col className="fs-4">
            Vendas em aberto
          </Col>
          {pagina && (
            <Col xs="auto">
              <Button variant="outline-secondary" onClick={()=>navigate('/vendas')} className="btn-sm">
                <i className="bi bi-x"></i>
              </Button>
            </Col>
          )}
        </Row>
        <VendasEmAberto pagina={pagina} />
        <Row className="d-flex justify-content-center align-items-center">
          <Col className="fs-4">
            Vendas
          </Col>
          <Col xs="auto">
              <Form.Group controlId="formSelectStock" className="mt-3">
                <Form.Control
                  as="select"
                  value={filtro}
                  onChange={(e) => setFiltro(e.target.value)}
                >
                  <option value="mes_atual">Mês atual</option>
                  <option value="mes_passado">Mês passado</option>
                  <option value="ultimos_30">Últimos 30 dias</option>
                  <option value="ultimos_60">Últimos 60 dias</option>
                  <option value="ultimos_90">Últimos 90 dias</option>
                  <option value="todo">Todo o período</option>
                  <option value="mes_selecao">Mês e ano</option>
                  <option value="personalizado">Personalizado</option>
                </Form.Control>
              </Form.Group>
          </Col>
        </Row>
        
        {filtro === 'mes_selecao' && (<>
            <Form.Group controlId="formDateRangeMes" className="mt-3">
                <div className="input-group">
                  <span className="input-group-text">Mês</span>
                  <Form.Control
                    as="select"
                    value={mesAno?.mes}
                    onChange={(e) => setMesAno((item)=>({
                      ...item,
                      mes:e.target.value
                    }))}
                  >
                    {meses.map((item, index) => (
                      <option key={index} value={index}>{item}</option>
                    ))}
                  </Form.Control>
                  <span className="input-group-text">Ano</span>
                  <Form.Control
                    as="select"
                    value={mesAno?.ano}
                    onChange={(e) => setMesAno((item)=>({
                      ...item,
                      ano:e.target.value
                    }))}
                  >
                    {anos.map((item) => (
                      <option key={item} value={item}>{item}</option>
                    ))}
                  </Form.Control>
                </div>
              </Form.Group>
        </>)}
        {filtro === 'personalizado' && (<>
            <Form.Group controlId="formDateRange" className="mt-3">
                <div className="input-group">
                  <span className="input-group-text">De</span>
                  <Form.Control
                    type="date"
                    value={dataInicio}
                    onChange={(e) => setDataInicio(e.target.value)}
                  />
                  <span className="input-group-text">até</span>
                  <Form.Control
                    type="date"
                    value={dataFim}
                    onChange={(e) => setDataFim(e.target.value)}
                  />
                </div>
              </Form.Group>
        </>)}

        <div className="list-group mt-2">
          {Object.entries(vendasAgrupadas).length > 0 ? (
            Object.entries(vendasAgrupadas).map(([data, vendasDoDia]) => (
              <div key={data}>
                <div className="text-muted mt-2" >{data}</div>
                {vendasDoDia.map((x) => (
                  <div key={x.id}>
                    <RenderizarProduto
                      lm='my-1'
                      to={`/vendas/${x.id}`}
                      src={getImgStatus(x)}
                      className="rounded-circle img-fluid"
                      text1={x.cliente?.nome_do_cliente}
                      titulo={(
                        <>
                          {parseFloat(x.desconto || 0)>0 && (
                            <>
                              <s className="small fs-6 text-muted">
                                {parseFloat(x.sub_total).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                              </s>
                              {` `}
                            </>
                          )}
                          {parseFloat(x.total).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                        </>
                      )}
                      text2={`Pago: ${parseFloat(x.total_pago).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} em aberto ${parseFloat(x.total_aberto||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`}
                    />
                  </div>  
                ))}
              </div>
            ))
          ) : (
            !loading && <p data-aos="fade-up" className="text-center text-muted">Nenhuma venda encontrada.</p>
          )}
          {loading && <p className="text-center" data-aos="fade-up"><Spinner animation="border" /></p>}
          {(!loading && nextUrl) && (
            <Button variant="secondary" data-aos="fade-up" onClick={() => buscarVendas(false)} className="mt-2">
              Buscar mais...
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

const MenuRodape = ({ extra }) => {
  if (!extra) return null;

  return (
    <div className="bs-floating shadow navbar-light">
      <div className="container py-1">
        <div className="row align-items-center">
          <div className="col">
            {extra.quantidade} venda{extra.quantidade>1?'s':''}
          </div>
          <div className="col-auto text-end">
            Total {' '} 
            <span className="fs-4">
              {parseFloat(extra.valor_total||0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};


const VendasEmAberto = ({pagina})=>{
  const [fiados, setFiados] = useState(0);
  const [parciais, setParciais] = useState(0);
  const { 
    setLinks, 
    setBtns,
    crud,
    salvarDados,
    buscarDadosPorId,
  } = useProvider();
  const { get } = crud|| {};
  
  useEffect(() => {
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
  }, []);
  const isConsultaCarregada = useRef(false);
  
  useEffect(()=>{
    const carregarLocal = async()=>{
      try{
        const response = await buscarDadosPorId('local_registros','count_vendas');
        if (isConsultaCarregada.current) return;
        if(response){
          const base = response;
          setFiados(base[0]?.count || 0);
          setParciais(base[1]?.count || 0);
        }
      }catch(err){
      }finally{
        
      }
    }
    const carregarContagem = async()=>{
      if (!get) return;
      try{
        const urls =[
          `/gvendas/vendas/?cliente__ativo=true&total_pago=0&filtros=id&limit=1`,
          `/gvendas/vendas/?cliente__ativo=true&total_pago__gt=0&total_aberto__gt=0&filtros=id&limit=1`
        ]
        const response = await get(urls);
        if(response && response.length){
          isConsultaCarregada.current = true;
          setFiados(response[0].count);
          setParciais(response[1].count);
          salvarDados('local_registros',{
            ...response,
            id:'count_vendas', 
          });
        }
      }catch(err){
        
      }
    }
    carregarLocal();
    carregarContagem();
  },[])
  
  
  return (<div className="list-group mt-2">
    <div data-aos="fade-up">
      <RenderizarProduto
        key={1}
        lm='my-1'
        bcolor={pagina === 'aberto'?'red':''}
        to={`?tipo=aberto`}
        src={`/images/img_fiado.jpg`}
        className="rounded-circle img-fluid"
        text1={`Não pagas`}
        text2={`${fiados} venda${fiados>1?'s':''} sem pagamento`}
      />
    </div>  
    <div data-aos="fade-up" data-aos-delay={50}>
      <RenderizarProduto
        key={1}
        lm='my-1'
        bcolor={pagina === 'parcial'?'red':''}
        to={`?tipo=parcial`}
        src={`/images/img_parcial.jpg`}
        className="rounded-circle img-fluid"
        text1={`Pagas parcialmente`}
        text2={`${parciais} venda${parciais>1?'s':''} sem o pagamento completo`}
      />
    </div>  
  </div>)
}

export default VendaList;
